// Module
var code = `<div class="card-actions"> <component-field></component-field> <div id="action-buttons"></div> </div> `;
// Exports
export default code;